$(document).ready(function () {
  $(window).on('popstate', function() {
       location.reload(true);
   });
  
  $('.apply-filter-button').on('click', function (e) {
    e.preventDefault();
    $(this).closest('.mobile-facets__wrapper').find('summary').trigger('click');
    
    const currentSearchParams = new URLSearchParams(window.location.search);
    currentSearchParams.set('facet', 'selected');
    
    const newUrl = `${window.location.pathname}?${currentSearchParams.toString()}`;
    window.location.href = newUrl;
  });

  $('.mobile-facets__clear').on('click', function (e) {
    e.preventDefault();
    const newUrl = window.location.pathname;
    window.location.href = newUrl;
  });
});
